import { css } from '@/styled-system/css';

// Hero artwork slot. Mobile: fluid-height block above the content (clamp
// keeps it from collapsing on short viewports). lg+: absolute-positioned
// inside <section className={heroSection}> so the headline overlay lays
// on top.
export const heroArtwork = css({
  display: 'block',
  position: 'relative',
  zIndex: 0,
  width: '100%',
  height: 'clamp(360px, 58svh, 520px)',
  overflow: 'hidden',
  flexShrink: 0,
  lg: {
    position: 'absolute',
    inset: '0',
    height: '100%',
    pointerEvents: 'none',
  },
});

export const heroArtworkImage = css({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
});
